import { gql } from '@/__generated__';

export const AIFilterFragment = gql(`
  fragment AIFilterFragment on AIFilter {
    id
    model
    name
    prompt
    collections {
      id
      name
    }
  }
`);

export const CollectionStreamPostFragment = gql(`
  fragment CollectionStreamPostFragment on StreamPost {
    id
    text
    createdAt
    deletedAt
    matchAiFilter
    authorId
    sourceId
    sourcePostId
    media {
      ...PostCardMediaFragment
    }
    stream {
      id
      label
      paidData {
        id
      }
      __typename
    }
    metadata {
        pairs {
          exchange
          value
          __typename
        }
      }
    enrichments {
      polymatcher
      translate
      __typename
    }
    __typename
  }
  `);

export const CustomCollectionPostFragment = gql(`
  fragment CustomCollectionPostFragment on StreamPost {
    ...CollectionStreamPostFragment
  }
`);

export const CustomCollectionFragment = gql(`
  fragment CustomCollectionFragment on CustomCollection {
    id
    name
    sources {
      id
      name
      description
      canAddToStreamDeck
      polymatcherEnabled
      author {
        id
      }
      customTargetsData {
        ...CustomTargetsDataFragment
      }
    }
    sourceConfigs {
      stream {
        id
      }
      customTargets
      usesAllTargets
      sourceIds
    }
    columnWidth
    filters {
      excludeKeywords {
        all
        any
        phrase
      }
      includeKeywords {
        all
        any
        phrase
      }
      highlightColor
      isHighlightEnabled
      regex
      ai {
        ...AIFilterFragment
      }
    }
    highlights {
      isEnabled
      values {
        regex
        color
      }
    }
    matchingSourcesOnly
  }
`);

export const StreamDeckFragment = gql(`
  fragment StreamDeckFragment on StreamDeck {
    id
    name
  }
`);
